import React from 'react';
import cx from 'classnames';
import { Envelope } from '../icons';
export var KountAccessWarning = function (props) {
    var className = props.className, kountIp = props.kountIp, textHead = props.textHead, textBody = props.textBody, textFoot = props.textFoot;
    var classes = cx('py-5', className);
    return (React.createElement("div", { className: classes },
        React.createElement("div", { className: "mb-5" },
            React.createElement(Envelope, { size: "56", className: "text--black" })),
        React.createElement("h4", { className: "mb-5" }, textHead),
        React.createElement("div", { className: "mb-5 text--regular text--lg" }, "".concat(textBody, " ").concat(kountIp && kountIp.replace(/^::ffff:/i, ''))),
        React.createElement("div", { className: "text--lg" }, textFoot)));
};
//# sourceMappingURL=KountAccessWarning.js.map